import { render, staticRenderFns } from "./postcard.vue?vue&type=template&id=a0c5c58a&scoped=true&"
import script from "./postcard.vue?vue&type=script&lang=js&"
export * from "./postcard.vue?vue&type=script&lang=js&"
import style0 from "./postcard.vue?vue&type=style&index=0&id=a0c5c58a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c5c58a",
  null
  
)

export default component.exports